// @flow
import React from "react";
import classnames from "classnames";

import { Row } from "./CommonComponents";
import { read, readAndReplace } from "modules/ChangeServiceForm/misc/utilities";

import { ReactComponent as Check } from "Commons/Assets/icons/check_circle_green.svg";

type Props = {
  content: { infoTitle: string, paragraphs: Array<string> },
  inheritedStyles: Object,
  categoryType: string,
  glossary: Object,
};

const InfoBox = ({ content, inheritedStyles, categoryType, glossary }: Props) => {
  const { infoBoxParagraphIcon, infoBoxParagraph, infoBoxTitle, infoBoxBilling, formRow } = inheritedStyles;

  return (
    <Row className={formRow}>
      <div className={classnames(infoBoxBilling, "theme-bgcolor-primary")}>
        <div className={infoBoxTitle}>{read(content.infoTitle)}</div>
        {content.paragraphs.map((paragraph, index) => {
          return (
            <p key={"infoBoxBillingParagraph_" + index} className={infoBoxParagraph}>
              <span className={infoBoxParagraphIcon}>
                <Check />
              </span>
              <span>
                {readAndReplace(content.paragraphs[index], {
                  replace: (domNode) => {
                    if (domNode.attribs && domNode.attribs.id === "replace") {
                      return <span>{categoryType && glossary[categoryType.toLowerCase()].trans}</span>;
                    }
                  },
                })}
              </span>
            </p>
          );
        })}
      </div>
    </Row>
  );
};

export default InfoBox;
